import { ORDER_SOURCE } from 'helpers/enums';

// Native app shells declare themselves by setting this global at document start.
// Deliberately not a user agent token: some parsers, detect-browser among them,
// anchor their patterns to the end of the user agent, so appending to it stops
// them recognising the WebView at all.
const NATIVE_SOURCE_GLOBAL = '__nextOrderAppSource';

const KNOWN_SOURCES = Object.values(ORDER_SOURCE);

export const getOrderSource = () => {
  const declared =
    (typeof window !== 'undefined' && window[NATIVE_SOURCE_GLOBAL]) || '';

  return KNOWN_SOURCES.includes(declared) ? declared : ORDER_SOURCE.web;
};

export const withOrderSource = (requestObj) => ({
  ...requestObj,
  order: { ...requestObj.order, source: getOrderSource() },
});
